import { lazy } from "react";

export const SupportAsync = lazy(() => import("./Support"));
